/**
 * This file is used only for complaints page Enhanced footer
 */

import _toNumber from 'lodash/toNumber';
import _filter from 'lodash/filter';
import _conforms from 'lodash/conforms';

import React, { Component } from 'react';
import ContactOption from '../ContactOption';

import i18n from '../../../lib/reacti18n';
import Page from '../../../lib/page';

import { trackLink } from '../../../lib/analytics-helper';
import { complaintsContactDefault } from '../../../lib/ContactDefaultData';

const messages = {
  heading: i18n.message('smarthelp/contactLinksOption.message.complaintsHeading'),
};

// Contact Panels label
const labels = {
  community: i18n.message('smarthelp/contactLinksOption.label.community'),
  resolution: i18n.message('smarthelp/contactLinksOption.label.resolution'),
  help_center: i18n.message('smarthelp/heroSection.heroLinks.helpcenter.largeScreen'),
  contact: i18n.message('smarthelp/contactLinksOption.label.contact'),
};

// importing function from page
const cobrand = Page.getCountry().toLowerCase();
// Checkout login Business user or content toggle switch to business url

const links = {
  community: Page.getCommunityLink(),
  resolution: Page.getResolutionURL(),
  contact: `/${cobrand}/smarthelp/contact-us`,
  help_center: `/${cobrand}/smarthelp/home`,
};

class ContactOptionsFooter extends Component {
  static getLabel(channelName) {
    return labels[channelName];
  }

  static getLink(channelName) {
    return links[channelName];
  }

  static getChannelActionAndLink(channelName) {
    const redirectLink = ContactOptionsFooter.getLink(channelName);
    if (redirectLink) {
      return {
        redirectLink,
        sameTab: channelName === 'contact' || channelName === 'help_center',
        action: () => {
          trackLink({ id: Page.getFPTIPageId(), link: `smarthelp-enhance-footer|${channelName}` });
          if (channelName === 'contact' || channelName === 'help_center') {
            window.location = redirectLink;
          } else {
            window.open(redirectLink, '_blank');
          }
        },
      };
    }
    return {};
  }

  static getIconClass(channelName) {
    return `vx_btn-link icon-${channelName}`;
  }

  /** Breaking rule class
   * If the number of channel less than 5, then using four padding rule
   * If the number of channel equal or more than 5, then using five padding rule
   */
  static getBreakLinkClass(channel) {
    const padNumber = (channel && channel.length <= 4) ? 'four' : 'five';
    return `contact-panels contact-panels-${padNumber}-padding vx_mainContent`;
  }

  // Display each of the Contact Option
  static getContactChannel(channel) {
    // key value is community, contact, resolution, tax or bussiness
    const key = channel.type;

    const actionLink = ContactOptionsFooter.getChannelActionAndLink(key);
    return (
      <li className="contact-option-list-item">
        <ContactOption
          key={key}
          id={key}
          contactLinkCSS="btn vx_btn-link contact-link"
          iconClass={ContactOptionsFooter.getIconClass(key)}
          text={ContactOptionsFooter.getLabel(key)}
          clickAction={actionLink.action}
          link={actionLink.redirectLink}
          sameTab={actionLink.sameTab}
        />
      </li>
    );
  }

  // technical community link filter
  static techCommunityFilter() {
    // Check is English locale
    const regex = /^en/;
    const locale = regex.test(Page.getLocale());

    // In technical exp, displaying Community option for English locale
    return !Page.isTechnicalExp() || locale;
  }

  // Get change option with initial data
  static getContactOption() {
    return complaintsContactDefault;
  }

  // Sort the display sequence by priority values
  static sortContactChannels() {
    return ContactOptionsFooter.getContactOption().sort((channel1, channel2) => (
      _toNumber(channel1.priority) - _toNumber(channel2.priority)
    ));
  }

  // Filter for community link
  static filterContactChannels() {
    const contactOption = ContactOptionsFooter.sortContactChannels();
    return _filter(contactOption,
      _conforms({ type: (type) => (links.community && ContactOptionsFooter.techCommunityFilter()) || type !== 'community' }));
  }

  static renderContactPanels() {
    const contactChannel = ContactOptionsFooter.filterContactChannels();

    return (
      <ul className={ContactOptionsFooter.getBreakLinkClass(contactChannel)}>
        {contactChannel.map((channel) => ContactOptionsFooter.getContactChannel(channel))}
      </ul>
    );
  }

  render() {
    return (
      <aside className="contact-container-footer">
        <h4 className="complaints-contact-heading-label">{messages.heading}</h4>
        {ContactOptionsFooter.renderContactPanels()}
      </aside>
    );
  }
}

export default ContactOptionsFooter;
